<script setup lang="ts">
  definePage({
    meta: {
      layout: 'admin',
    },
  })
</script>

<template>
  <RouterView />
</template>

<style scoped lang="scss">
  .home-page {
    &__container {
      flex-wrap: wrap;
      gap: 16px;
    }
    &__combined-cells {
      gap: 16px;
    }
  }
</style>
